module.exports = "<ul>\r\n    <li ng-repeat=\"reg in regs\">\r\n        <a href=\"#\" ng-click=\"goToVehicle(reg.item1)\">{{reg.item2}}</a>\r\n    </li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/templates/contact/contactViewEnquiryRegs.html
// module id = 1958
// module chunks = 0